import { createColumnHelper } from "@tanstack/react-table";
import { YourPropertiesProps } from "./recent-properties.interface";
import styles from "../dashboard-properties/recent-properties.module.scss";
// import { Skeleton } from "primereact/skeleton";
// import { Accordion, AccordionTab } from "primereact/accordion";
import {
  countDaysFromDate,
  dateFormat,
  formatCurrency,
  StatusObjectColorFilter
} from "../../utils/utils";
// import { useState } from "react";
import CustomAccordion from "./custom-accordion";
import React from "react";
import Like from "../common/like";
import { Tag } from "primereact/tag";
import PriceDropTag from "../common/pricedrop-tag";
const useColumnsYourOffers = (type: string = "agent") => {
  const columnHelper = createColumnHelper<YourPropertiesProps>();
  const OffersColumns: any = [
    columnHelper.accessor("posterImage", {
      id: "Image",
      header: "",
      cell: (props: any) => {
        return (
          <div className={styles.imgWrap}>
            {/* {props ? ( */}
            <div className={styles.propertyImgWrap}>
              {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
              <img
                src={props.getValue()}
                alt="Image"
                width="20%"
                className={styles.propertyImg}
                // onError={(e: any) => {
                //   e.target.src = "/images/default-property.jpg";
                //   e.target.alt = "Image not available";
                // }}
              />
              {type === "agent" && (
                <div className={styles.daysCount}>
                  <Tag
                    value={
                      countDaysFromDate(props.row.original?.createdAt) > 1
                        ? `${countDaysFromDate(
                            props.row.original?.createdAt
                          )} Days ago`
                        : `${countDaysFromDate(
                            props.row.original?.createdAt
                          )} Day ago`
                    }
                    style={{
                      background: "#0000008a",
                      color: "#ffffff"
                    }}
                    className={styles.tagClass}
                  />
                </div>
              )}
            </div>
            <div className={styles.address}>
              <div>{props.row.original.street}</div>
              <div
                className={styles.text}
              >{`${props.row.original.city}, ${props.row.original.state}, ${props.row.original.postalcode}`}</div>
              <CustomAccordion
                header={`Bid History (${
                  props.row.original?.yourOffers?.length || 0
                })`}
                offers={props.row.original?.yourOffers || []}
              />
            </div>
            {/* ) : (
              <Skeleton
                width="18.625rem"
                height="3.875rem"
                className={styles.address}
              />
            )} */}
          </div>
        );
      }
    }),
    columnHelper.accessor("yourOffers", {
      id: "you-bid",
      header: "YOUR BID",
      cell: (props: any) => (
        <>
          <span className={`${styles.highestOffer} ${styles.textAlign}`}>
            {
              props.row.original?.yourOffers?.reduce(
                (
                  prev: { offerAmount: number },
                  curr: { offerAmount: number }
                ) => {
                  return Math.max(prev.offerAmount, curr.offerAmount);
                },
                { offerAmount: -Infinity }
              ).offerAmount
            }

            {formatCurrency(
              Math.max(
                ...props.row.original?.yourOffers?.map(
                  (offer: { offerAmount: any }) => offer.offerAmount
                )
              ),
              "USD",
              "en-US",
              0,
              0
            )}
          </span>
          <PriceDropTag
            type={"agent"}
            priceDrop={props.row.original.priceDrop}
            priceDropDate={props.row.original.priceDropDate}
          />
          {/* <a href='/dashboard/#' className={styles.addOffer}>
            Add Offer
          </a> */}
        </>
      )
    }),
    // columnHelper.accessor('offers', {
    //   id: 'offers',
    //   header: 'OFFERS',
    //   cell: (props: any) => (
    //     <span className={styles.highestOffer}>
    //       {formatNumber(props.getValue(), 0, 0)}
    //     </span>
    //   ),
    // }),
    columnHelper.accessor("yourOffers", {
      id: "bid-submitted",
      header: "BIDS SUBMITTED",
      cell: (props: any) => (
        <div>
          <span className={styles.offerSubmitted}>
            {/* {dateFormat(props.getValue(), 'MM/DD/YYYY')} */}
            {dateFormat(
              props.row.original?.yourOffers?.reduce(
                (
                  prev: { offerAmount: number },
                  curr: { offerAmount: number }
                ) => {
                  return Math.max(prev.offerAmount, curr.offerAmount);
                },
                { offerAmount: -Infinity }
              ).offerSubmittedDate,
              "MM/DD/YYYY"
            )}
          </span>
          <span className={styles.offerSubmittedTime}>
            {dateFormat(
              props.row.original?.yourOffers?.reduce(
                (
                  prev: { offerAmount: number },
                  curr: { offerAmount: number }
                ) => {
                  return Math.max(prev.offerAmount, curr.offerAmount);
                },
                { offerAmount: -Infinity }
              ).offerSubmittedDate,
              "hh: mm A"
            )}
          </span>
        </div>
      )
    }),
    columnHelper.accessor("offerDueDateAndTime", {
      id: "due-date",
      header: "DUE DATE",
      cell: (props: any) => (
        <span className={styles.highestOffer}>
          {props.getValue() && dateFormat(props.getValue(), "MM/DD/YYYY")}
        </span>
      )
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: "STATUS",
      cell: (props: any) => (
        <span className={styles.status}>
          {props.getValue() && (
            <span
              className={`${styles.circle}`}
              style={{
                backgroundColor:
                  StatusObjectColorFilter(props.getValue())?.bgColor ||
                  "#0000008a"
              }}
            />
          )}
          {props.getValue()}
        </span>
      )
    }),
    columnHelper.accessor("favCount", {
      id: "like",
      header: "",
      cell: (props: any) => {
        const currentPageData = props.table.getRowModel().rows;
        return (
          <span className={props.getValue()}>
            <Like
              loginType={"agent"}
              propertyId={props.row.original?.id}
              favCount={props.row.original?.favCount}
              width={25}
              isSavedProperty={true}
              currentPageItemCount={currentPageData.length}
              objPropertyDetails={props.row.original}
            />
          </span>
        );
      }
    })
  ];
  return { OffersColumns };
};

export default useColumnsYourOffers;
